<template>
  <div id="bpmnEditor">
    <div class="tooling">
      <IconTooltipButton
        icon="mdi-image-filter-center-focus-weak"
        tooltip="Zoom zurücksetzen"
        id="default"
        @click="resetZoom()"
      />
      <v-divider style="margin: 2.5px"></v-divider>
      <IconTooltipButton
        icon="mdi-plus"
        tooltip="zoom in"
        id="default"
        @click="zoomIn()"
      />
      <v-divider style="margin: 2.5px"></v-divider>
      <IconTooltipButton
        icon="mdi-minus"
        tooltip="zoom out"
        id="default"
        @click="zoomOut()"
      />
    </div>
    <div id="topTooling">
      <IconTooltipButtonBottom
        icon="mdi-undo"
        tooltip="Zurück"
        id="topToolingBtn"
        @click="undo()"
      />
      <v-divider vertical></v-divider>
      <IconTooltipButtonBottom
        icon="mdi-redo"
        tooltip="Vorwärts"
        id="topToolingBtn"
        @click="redo()"
      />
    </div>
    <div
      ref="container"
      class="vue-bpmn-diagram-container"
      id="modelerContainer"
    ></div>
    <!--     <div id="canvas" v-bind:class="{ propertiesOpened: showPropertiesPanel, propertiesClosed: !showPropertiesPanel}">
      <div ref="container" class="vue-bpmn-diagram-container" id="modelerContainer"></div>
      <v-btn
        outlined
        large
        absolute
        right
        style="top: 50%; transform:translateY(-50%) rotate(-90deg); margin-right: -85px; visibility:hidden;"
        v-bind:style="{ background: $vuetify.theme.themes.light.background}"
        @click="showPropertiesPanel = !showPropertiesPanel"
      >Properties Panel</v-btn>
    </div>

      <v-card
      class="properties-panel-parent right"
      id="properties-panel"
      ref="propertiespanel"
      v-bind:class="{ propertiesPropertiesOpened: showPropertiesPanel, propertiesPropertiesClosed: !showPropertiesPanel}"
    ></v-card> -->
    <AdditionalContextInformationPicker ref="addDialog" />
    <ConnectedRessourceDialog ref="ressourceDialog" />
    <ConfirmDialog ref="confirmDialog" />
    <PickConnectedSubprocessDialog ref="subprocessDialog" />
    <ShowItemDetailsDialog ref="showItemDialog" />
  </div>
</template>

<script>
//Modeler dependencies and css files
import BpmnModeler from "prime-custom-modeling/lib/Modeler";
import "prime-custom-modeling/dist/assets/diagram-js.css";
import "prime-custom-modeling/dist/assets/bpmn-font/css/bpmn.css";

//needed for properties-panel
/* import "bpmn-js-properties-panel/styles/properties.less"; */

//properties-panel imports
/* import propertiesPanelModule from "bpmn-js-properties-panel";
import propertiesProviderModule from "bpmn-js-properties-panel/lib/provider/camunda"; */
import camundaModdleDescriptor from "camunda-bpmn-moddle/resources/camunda.json";

import customControlsModule from "@/modules/CustomElementsEditorModule";
import { getBusinessObject } from "prime-custom-modeling/lib/util/ModelUtil";

import customElementExtension from "@/resources/customElementType.json";
import postit from "@/resources/postit.json";
import AdditionalContextInformationPicker from "@/components/common/AdditionalContextInformationPicker.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import IconTooltipButton from "@/components/common/IconTooltipButton";

var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import customModelingElementService from "@/components/customModelingElementsService";
import connectedRessourceService from "@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService";
import ConnectedRessourceDialog from "@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/ConnectedRessourceDialog.vue";
import PickConnectedSubprocessDialog from "@/pages/ProcessModeling/CustomModelingTools/ConnectedSubprocess/PickConnectedSubprocessDialog.vue";
import ShowItemDetailsDialog from "@/components/common/ShowItemDetailsDialog.vue";
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom";
import elementNumberService from "../../components/elementNumberService";

export default {
  components: {
    AdditionalContextInformationPicker,
    ConfirmDialog,
    ConnectedRessourceDialog,
    PickConnectedSubprocessDialog,
    IconTooltipButton,
    ShowItemDetailsDialog,
    IconTooltipButtonBottom,
  },
  props: {
    diagramXML: {
      type: String,
    },
  },

  data: function () {
    return {
      showPropertiesPanel: false,
      ressourcesToConnect: [],
      ressourceToDelete: [],
      commandStack: null,
      eventBus: null,
      initialElements: [],
    };
  },
  mounted: function () {
    this.initModeler();
  },
  beforeDestroy: function () {
    if (this.BpmnModeler) this.BpmnModeler.destroy();
  },
  watch: {
    diagramXML: function (val) {
      this.importProcess();
    },
  },
  computed: {},
  methods: {
    undo() {
      if (this.BpmnModeler) {
        let commandStack = this.BpmnModeler.get("commandStack");
        commandStack.undo();
      }
    },
    redo() {
      if (this.BpmnModeler) {
        let commandStack = this.BpmnModeler.get("commandStack");
        commandStack.redo();
      }
    },
    isCustomElement(element) {
      const businessObject = getBusinessObject(element);
      if (
        (businessObject != null && businessObject.taskType != null) ||
        (businessObject.$attrs != null &&
          businessObject.$attrs.taskType != null)
      ) {
        return true;
      }
      return false;
    },
    isPostit(element) {
      const businessObject = getBusinessObject(element);
      if (
        businessObject != null &&
        businessObject.taskType != null &&
        businessObject.taskShape != null
      ) {
        return true;
      } else if (
        businessObject.$attrs != null &&
        businessObject.$attrs.taskType != null &&
        businessObject.$attrs.taskShape != null
      ) {
        return true;
      }
      return false;
    },
    async initModeler() {
      const customModelingElements =
        await customModelingElementService.getCustomModelingElements();
      this.$store.dispatch("initModelingElements", customModelingElements.data);

      var container = this.$refs.container;

      /* const propertiesPanel = this.$refs.propertiespanel; */

      this.BpmnModeler = new BpmnModeler({
        container: container,
        keyboard: { bindTo: document },

        //for properties Panel add here propertiesPanelModule, propertiesProviderModule
        additionalModules: [customControlsModule],
        moddleExtensions: {
          camunda: camundaModdleDescriptor,
          qa: customElementExtension,
          postit: postit,
        },
      });

      let self = this;
      this.BpmnModeler.on("import.done", function (event) {
        var error = event.error;
        var warnings = event.warnings;

        if (error) {
          self.$emit("error", error);
        } else {
          self.$emit("shown", warnings);
        }

        self.BpmnModeler.get("canvas").zoom("fit-viewport", "auto");
        let rootElement = self.BpmnModeler._definitions.rootElements[0];
        self.$emit("elementClicked", rootElement);
        self.setBadges();
        const elements = self.BpmnModeler.get("elementRegistry").getAll();
        self.initialElements = elements.map((e) => e.id);
      });

      this.BpmnModeler.on("create.start", function (event) {
        const businessObject = getBusinessObject(event.elements[0]);
        if (businessObject && businessObject.taskType == "ADD") {
          event.stopPropagation();
          self.$refs.addDialog.open().then(() => {
            self.$emit("saveFile");
          });
        }
      });

      this.BpmnModeler.on("shape.remove", function (event) {
        if (
          event.element.type == "bpmn:DataStoreReference" ||
          event.element.type == "bpmn:Lane"
        ) {
          self.ressourceToDelete.push(event.element.id);
        }
      });

      let eventBus = this.BpmnModeler.get("eventBus");
      this.eventBus = eventBus;
      eventBus.on("element.dblclick", 1500, function (event) {
        if (event.element.type == "bpmn:SubProcess") {
          self.openSubprocessDialog(event.element, event);
        } else if (event.element.id.includes("label")) {
          let element = event.element.labelTarget;
          self.openRessourceDialog(element, event);
        } else if (
          !self.isCustomElement(event.element) &&
          !self.isPostit(event.element)
        ) {
          self.openRessourceDialog(event.element, event);
        } else if (self.isCustomElement(event.element)) {
          self.openRessourceDialog(event.element, event);
        } else if (!self.isPostit(event.element)) {
          event.preventDefault();
          event.stopPropagation();
        }
      });

      //Use for debugging thrown events to log all occuring events
      /* const fire = eventBus.fire.bind(eventBus);

      eventBus.fire = (type, data) => {
        console.log(type, data);
        fire(type, data);
      }; */

      eventBus.on("commandStack.postExecuted", (event) => {
        if (event.command == "lane.add") {
          self.openRessourceDialog(event.context.newLane, event);
        }
      });

      eventBus.on("copyPaste.elementsCopied", (event) => {
        let elementsToCopy = [];
        event.elements.forEach((elem) => {
          let bo = getBusinessObject(elem);
          if (
            !elem.type.includes("bpmn:DataStoreReference") &&
            bo.taskType == null
          ) {
            elementsToCopy.push(elem);
          } else {
            for (const [key, value] of Object.entries(event.tree)) {
              event.tree[key] = value.filter((e) => !e.id.includes(elem.id));
            }
          }
        });
        event.elements = elementsToCopy;
      });

      eventBus.on("element.contextmenu", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const businessObject = getBusinessObject(event.element);
        let element = event.element;
        if (element.type == "bpmn:SubProcess") {
          const businessObject = getBusinessObject(element);
          let uuid = businessObject.$attrs.subProcess;
          let name = businessObject.name;
          if (uuid == null) {
            if (name != null && name.includes("(nicht verknüpft)")) {
              alert(
                "Processmodell muss erst verknüpft werden bevor es geöffnet werden kann"
              );
            }
            return;
          }
          this.$emit("switchModel", uuid);
        } else if (businessObject.ressource != null) {
          this.openShowItemDetailsDialog(element);
        }
      });

      eventBus.on("shape.added", function (event) {});

      this.BpmnModeler.on("create.end", function (event) {
        const elements = event.elements;

        const moddle = self.BpmnModeler.get("moddle");
        const modeling = self.BpmnModeler.get("modeling");
        elements.forEach((element) => {
          const businessObject = getBusinessObject(element);
          if (
            !businessObject.hasOwnProperty("taskType") &&
            !businessObject.hasOwnProperty("connectedSystem")
          ) {
            if (businessObject.$type == "bpmn:SubProcess") {
              self.openSubprocessDialog(element, event);
            } else {
              self.openRessourceDialog(element, event);
            }
          } else {
            if (
              !businessObject.hasOwnProperty("taskType") &&
              !businessObject.hasOwnProperty("icon")
            )
              return;
            self.openRessourceDialog(element, event);
            let ContextInformations = self.getExtensionElement(
              businessObject,
              "qa:ContextInformations"
            );
            const extensionElements =
              businessObject.extensionElements ||
              moddle.create("bpmn:ExtensionElements");

            if (!ContextInformations) {
              ContextInformations = moddle.create("qa:ContextInformations");

              extensionElements.get("values").push(ContextInformations);
            }
            ContextInformations.taskType = businessObject.taskType;
            ContextInformations.icon = businessObject.icon;
            ContextInformations.taskShape = businessObject.taskShape;
            ContextInformations.taskColor = businessObject.taskColor;

            modeling.updateProperties(element, {
              extensionElements,
              taskType: businessObject.taskType,
              icon: businessObject.icon,
              taskShape: businessObject.taskShape,
              taskColor: businessObject.taskColor,
            });
          }
        });
      });

      this.importProcess();
    },
    openShowItemDetailsDialog(element) {
      const businessObject = getBusinessObject(element);
      this.$refs.showItemDialog.open(businessObject.ressource);
    },
    openSubprocessDialog(element, event) {
      const modeling = this.BpmnModeler.get("modeling");
      const businessObject = getBusinessObject(element);
      let self = this;
      let processUuid = null;
      processUuid = businessObject.$attrs.subProcess;
      this.$refs.subprocessDialog
        .open(processUuid)
        .then((process) => {
          if (process == null) {
            if (this.eventBus != null) {
              this.eventBus.on("element.changed", function (event) {
                const elem = event.element;
                if (
                  elem.businessObject &&
                  elem.businessObject.$type === "bpmn:SubProcess" &&
                  elem.id == element.id
                ) {
                  const currentLabel = element.businessObject.name || "";
                  if (!currentLabel.includes("(nicht verknüpft)")) {
                    const newLabel = `${currentLabel} (nicht verknüpft)`;
                    modeling.updateProperties(elem, {
                      name: newLabel,
                    });
                    businessObject.set("subProcess", null);
                  }
                }
              });
            }
          }
          event.stopPropagation();
          modeling.updateProperties(element, {
            name: process.fileName,
          });

          businessObject.set("subProcess", process.uuid);
          self.$emit("saveFile");
        })
        .catch((e) => {
          //if(!processUuid) modeling.removeElements([element])
        });
    },
    openRessourceDialog(element, event) {
      const businessObject = getBusinessObject(element);
      const modeling = this.BpmnModeler.get("modeling");
      let self = this;
      let nameToReplace = "";
      let ressourceType = null;
      if (businessObject.taskType != null && businessObject.icon != null) {
        ressourceType = "CONTEXT_ITEM";
        nameToReplace = "DataStoreReference";
      } else if (businessObject.$type == "bpmn:DataStoreReference") {
        ressourceType = "SYSTEM";
        nameToReplace = "DataStoreReference";
      } else if (businessObject.$type == "bpmn:Lane") {
        ressourceType = "ROLE";
        nameToReplace = "Lane";
      } else if (businessObject.$type == "bpmn:Lane") {
        ressourceType = "ROLE";
        nameToReplace = "Lane";
      }
      if (ressourceType == null) return;
      self.$refs.ressourceDialog
        .open(ressourceType, true, false)
        .then((ressource) => {
          let name = ressource.friendlyName
            ? ressource.friendlyName
            : ressource.name;
          let id = element.id.replace(nameToReplace, ressource.name);
          modeling.updateProperties(element, {
            name: name,
            id: id,
          });
          const businessObject = getBusinessObject(element);
          businessObject.ressource = ressource;
          let uuid = self.$route.params.uuid;
          const ressourceModelElement = {
            ressourceId: ressource.id,
            processId: uuid,
            elementId: [id],
          };
          self.ressourcesToConnect.push(ressourceModelElement);
        })
        .catch((e) => {
          //modeling.removeElements([element])
        });
      event.stopPropagation();
    },
    getExtensionElement(element, type) {
      if (!element.extensionElements) {
        return;
      }

      return element.extensionElements.values.filter((extensionElement) => {
        return extensionElement.$instanceOf(type);
      })[0];
    },
    importProcess() {
      let self = this;
      if (this.BpmnModeler == null) return;
      this.BpmnModeler.importXML(this.diagramXML)
        .then(() => {
          var eventBus = self.BpmnModeler.get("eventBus");

          eventBus.on("element.click", function (event) {
            self.$emit("elementClicked", event.element);
          });
          self.setBadges();
        })
        .catch((err) => console.log("something went wrong:", err));
    },
    setBadges() {
      let overlays = this.BpmnModeler.get("overlays");
      let elementRegistry = this.BpmnModeler.get("elementRegistry");
      this.$emit("createBadge", overlays, elementRegistry);
    },
    async saveFile() {
      return new Promise((resolve, reject) => {        var self = this;
        this.syncConnectedSystems().then(() => {
          const currentElements =
            self.BpmnModeler.get("elementRegistry").getAll();
          const removedIds = self.initialElements.filter(
            (id) => !currentElements.some((e) => e.id === id)
          );
          removedIds.forEach(async (id) => {
            let uuid = self.$route.params.uuid;
            await elementNumberService.removeElementNumber(uuid, id);
          });
          self.BpmnModeler.saveXML({ format: true }, (err, xml) => {
            if (err) {
              reject(err);
            }
            resolve(xml);
          });
        });
      });
    },
    async syncConnectedSystems() {
      let self = this;
      this.ressourcesToConnect.forEach(async (elem) => {
        let isDeleted = self.ressourceToDelete.indexOf(elem.elementId[0]);
        if (isDeleted > -1) {
          self.ressourceToDelete.splice(isDeleted, 1);
        } else {
          await connectedRessourceService.saveRessourceForModelElement(elem);
        }
      });

      this.ressourceToDelete.forEach(async (elementId) => {
        await connectedRessourceService.deleteRessourceForModelElements(
          elementId
        );
      });

      this.ressourcesToConnect = [];
      this.ressourceToDelete = [];
    },
    exportPDF() {
      return new Promise((resolve, reject) => {
        this.BpmnModeler.saveSVG({ format: true }, (err, svg) => {
          if (err) {
            reject(err);
          }
          resolve(svg);
        });
      });
    },
    exportXML() {
      return new Promise((resolve, reject) => {
        this.BpmnModeler.cleanXML({ format: true }, (err, xml) => {
          if (err) {
            reject(err);
          }
          resolve(xml);
        });
      });
    },
    resetZoom() {
      this.BpmnModeler.get("canvas").zoom("fit-viewport", "auto");
    },
    zoomIn() {
      this.BpmnModeler.get("zoomScroll").stepZoom(1);
    },
    zoomOut() {
      this.BpmnModeler.get("zoomScroll").stepZoom(-1);
    },
    resetColorsInModel() {
      const elements = this.BpmnModeler.get("elementRegistry").getAll();

      if (elements == null) return;

      elements.forEach((element) => {
        if (element == null) return;
        const businessObject = element.businessObject;

        businessObject.di.set("stroke", "");
        businessObject.di.set("fill", "");

        const gfx =
          this.BpmnModeler.get("elementRegistry").getGraphics(element);

        const type = element.waypoints ? "connection" : "shape";
        const graphix = this.BpmnModeler.get("graphicsFactory");
        graphix.update(type, element, gfx);
      });
    },
    colorElementInModel(elementId, stroke, fill) {
      const element = this.BpmnModeler.get("elementRegistry").get(elementId);
      if (element == null) return;
      const businessObject = element.businessObject;

      businessObject.di.set("stroke", stroke);
      businessObject.di.set("fill", fill);
      businessObject.di.set("opacity", 0.2);

      const gfx = this.BpmnModeler.get("elementRegistry").getGraphics(element);

      const type = element.waypoints ? "connection" : "shape";
      const graphix = this.BpmnModeler.get("graphicsFactory");
      graphix.update(type, element, gfx);
    },
    setEvaluationBadges() {
      let overlays = this.BpmnModeler.get("overlays");
      let elementRegistry = this.BpmnModeler.get("elementRegistry");
      this.$emit("createEvaluationBadge", overlays, elementRegistry);
    },
    hideEvaluationBadges() {
      let overlays = this.BpmnModeler.get("overlays");
      let elementRegistry = this.BpmnModeler.get("elementRegistry");
      this.$emit("hideEvaluationBadges", overlays, elementRegistry);
    },
  },
};
</script>
<style>
.vue-bpmn-diagram-container {
  width: 100%;
}
#bpmnEditor,
#modelerContainer {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: white;
}
#canvas,
#properties-panel {
  position: absolute;
}
#canvas {
  top: 0;
  left: 0;
  bottom: 0;
}
#properties-panel {
  top: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  margin-top: 1px;
  background-color: white;
}
.propertiesOpened {
  right: 300px;
}
.propertiesClosed {
  right: 0;
}
.propertiesPropertiesOpened {
  width: 300px;
}
.propertiesPropertiesClosed {
  width: 0;
}
.bpp-properties-panel {
  background-color: white !important;
}

.tooling {
  border: 1px solid lightgray;
  position: absolute;
  bottom: 75px;
  right: 15px;
  z-index: 100;
  background-color: white;
  text-align-last: center;
}
#topTooling {
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 100;
  background-color: white;
  text-align-last: center;
}
#topToolingBtn {
  border: 1px solid lightgray;
  border-radius: 10px;
  color: black;
  margin: 0px 2.5px;
}
.btn {
  min-width: 0px !important;
  height: 28px;
  width: 28px;
}
</style>